import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { getDecodedToken, logout } from "../../../api-handle/authService";

const UserHeader = () => {
  const history = useNavigate();
  const [name, setName] = useState("");
  const [type, setType] = useState("Merchant");

  useEffect(() => {
    const decoded = getDecodedToken();
    if (decoded) {
      setName(decoded.name || "Unknown");
      setType(decoded.type || "Merchant");
    }
  }, []);

  const getInitials = (fullName) => {
    return fullName
      .split(" ")
      .map((n) => n[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();
  };

  const goToProfile = () => {
    history("/merchant/profile");
  };

  const handleLogout = () => {
    // logout() is single-flight internally, so double-clicks are already safe.
    logout(); // clears auth keys + reloads → PrivateRoute redirects to /login
  };

  return (
    <li
      className="profile-nav pe-0 py-0 d-flex align-items-center"
      style={{ cursor: "pointer" }}
    >
      <div
        className="media profile-media align-items-center"
        onClick={goToProfile}
        style={{ marginRight: "15px" }}
      >
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            backgroundColor: "#0d6efd",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            fontSize: "14px",
          }}
        >
          {getInitials(name)}
        </div>
        <div className="media-body">
          <span>{name}</span>
          <p className="mb-0 font-roboto">{type}</p>
        </div>
      </div>

      <LogOut onClick={handleLogout} className="text-red-500" size={14} />
    </li>
  );
};

export default UserHeader;
